import { useParams } from 'react-router-dom'
import ContentPageLayout from 'components/ContentPageLayout'
import s from './index.module.scss'

const Tips = (): JSX.Element => {
	const { role } = useParams()

	return (
		<ContentPageLayout
			contentKey={'tips_' + role}
			type="collapsing"
			containerClassName={s.container}
		/>
	)
}

export default Tips
